import { applyMiddleware, createStore, combineReducers, compose } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'

import mayaReducer from './maya/reducers'
import generalReducer from './general/reducers'
import errorReducer from './error/reducers'
import loadingReducer from './loading/reducers'

const rootReducer = combineReducers({
  loading: loadingReducer,
  error: errorReducer,
  maya: mayaReducer,
  general: generalReducer,
})

let composeEnhancers = null

if (typeof window !== 'undefined') {
  // browser code
  /* @ts-ignore */
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
} else {
  composeEnhancers = compose
}

const middlewares = [promise, thunk]

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares))
)

export default store
